import {OPTION_COUNTRIES} from '../../../../_gori/constants'

export const SettingsConfig = {
  TEMU: {
    APPLICATION_ID: process.env.REACT_APP_AMAZON_APPLICATION_ID,
    TYPE: [
      {
        label: 'LOCAL_SELLER',
        value: 'local_seller',
      },
    ],
    REGION: [
      {
        label: 'US_TEMU_PARTNER_PLATFORM',
        value: {url: 'https://partner.temu.com', code: 'us'},
      },
      // {
      //   label: 'EU_TEMU_PARTNER_PLATFORM',
      //   value: {url: 'https://partner-eu.temu.com', code: 'eu'},
      // },
    ],
  },
  // shipping
  PAGE_SIZE_ADDRESS: 200,
  OPTIONS_ORDER: [
    {label: 'BAE_ID', value: 'order_code'},
    {label: 'REFERENCE_1', value: 'reference1'},
    {label: 'REFERENCE_2', value: 'reference2'},
  ],
  OPTIONS_BARCODE: [
    {label: 'REFERENCE_1', value: 'reference1'},
    {label: 'REFERENCE_2', value: 'reference2'},
    {label: 'ITEM_SKU', value: 'sku'},
    {label: 'BAE_ID', value: 'order_code'},
  ],
  OPTIONS_LABEL_TYPE: [
    {label: 'PDF (One File)', value: 'pdf'},
    {label: 'PDF (Separate Files)', value: 'pdf_separate'},
    {label: 'PNG', value: 'png'},
    // {label: 'ZPL', value: 'zpl'},
  ],
  OPTIONS_LABEL_SIZE: [
    {label: '4x6', value: '4x6'},
    {label: '8.5x11', value: '8.5x11'},
    // {label: 'PNG', value: 'png'},
    // {label: 'ZPL', value: 'zpl'},
  ],
  OPTIONS_PRINT_COLUMN: [
    {label: 'BAE_ID', value: 'code'},
    {label: 'REFERENCE_1', value: 'reference1'},
    {label: 'REFERENCE_2', value: 'reference2'},
  ],
  OPTIONS_PRINT_ORDER: [
    {label: 'ASCENDING', value: 'asc'},
    {label: 'DESCENDING', value: 'desc'},
  ],
  LABELS_SLIPS: {
    LABELS: {
      TYPE: {label: 'TYPE', value: 'label_type'},
      SIZE: {label: 'PACKING_SLIP_SIZE', value: 'packing_slip_size'},
      INCLUDE_SLIPS: {
        label: 'INCLUDE_PACKING_SLIPS_WHEN_PRINTING_LABELS',
        value: 'include_slips',
      },
      PRINT_ORDER: {
        label: 'PRINT_ORDER',
        value: 'print_order',
      },
    },
    SLIPS: {
      HEADER: {label: 'HEADER', value: 'header'},
      ORDER_NUMBER: {label: 'ORDER', value: 'order'},
      // ORDER_NOTE: {label: 'ADD_ORDER_NOTE', value: 'order_note'},
      ORDER_DATE: {label: 'ORDER_DATE', value: 'order_date'},
      SHIP_TO: {label: 'SHIP_TO', value: 'ship_to'},
      SHIPPING_SERVICE: {label: 'SHIPPING_SERVICE', value: 'shipping_service'},
      TRACKING: {label: 'TRACKING', value: 'tracking'},
      BARCODE: {label: 'BARCODE', value: 'barcode'},
      ITEM_DETAIL: {label: 'ITEM_DETAIL', value: 'item_detail'},
      COMPANY_POLICY: {label: 'COMPANY_POLICY', value: 'company_policy'},
      FOOTER: {label: 'FOOTER', value: 'footer'},
      STORE_LOGO: {label: 'STORE_LOGO', value: 'store_logo'},
      STORE_NAME: {label: 'STORE_NAME', value: 'store_name'},
      THIRD_PARTY_NAME: {
        label: 'UTILIZE_THE_EXISTING_3RD_PARTY_STORE_NAME',
        value: 'third_party_name',
      },
      STORE_LOCATION: {label: 'STORE_LOCATION', value: 'store_location'},
    },
  },
  STORE_LOCATION: {
    ADDRESS: {label: 'ADDRESS', value: 'address', required: true},
    ADDRESS_2: {label: 'ADDRESS_2', value: 'address_2', required: false},
    CITY: {label: 'CITY', value: 'city', required: true},
    STATE: {label: 'STATE', value: 'state', required: true},
    COUNTRY: {label: 'COUNTRY', value: 'country', required: true},
    ZIP: {label: 'POSTAL_CODE', value: 'zip', required: true},
  },
  VALIDATE_FILE: {
    SIZE: 8388608,
    EXTENSION_ALLOW: ['jpg', 'jpeg', 'png'],
  },

  // preset
  DEFAULT_PRESETS: {
    SHIPBAE: {
      label: 'SHIPBAE',
      value: 'shipbae',
      isAllowedClearValue: true,
      logoPath: '/media/gori/settings/shipbae.png',
    },
    SHOPIFY: {
      label: 'SHOPIFY',
      value: 'shopify',
      isAllowedClearValue: true,
      logoPath: '/media/gori/settings/shopify.png',
    },
    SHIPSTATION: {
      label: 'SHIPSTATION',
      value: 'shipstation',
      isAllowedClearValue: true,
      logoPath: '/media/gori/settings/shipstation.png',
    },
    WOOCOMMERCE: {
      label: 'WOOCOMMERCE',
      value: 'woocommerce',
      isAllowedClearValue: true,
      logoPath: '/media/gori/settings/woocommerce.png',
    },
    MAGENTO2: {
      label: 'MAGENTO2',
      value: 'magento2',
      isAllowedClearValue: true,
      logoPath: '/media/gori/settings/magento2.png',
    },
    WALMART: {
      label: 'WALMART',
      value: 'walmart',
      isAllowedClearValue: true,
      logoPath: '/media/gori/settings/walmart.png',
    },
    TIKTOK: {
      label: 'TIKTOK',
      value: 'tiktok',
      isAllowedClearValue: true,
      logoPath: '/media/gori/settings/tiktok.png',
    },
    EBAY: {
      label: 'EBAY',
      value: 'ebay',
      isAllowedClearValue: true,
      logoPath: '/media/gori/settings/ebay.png',
    },
    TEMU: {
      label: 'TEMU',
      value: 'temu',
      isAllowedClearValue: false,
      logoPath: '/media/gori/settings/temu.png',
    },
  },
  SHOW_PRESET: {
    PRESET_NAME: {name: 'PRESET_NAME', show: true},
    SHIP_FROM: {name: 'SHIP_FROM', show: false},
    SHIP_TO: {name: 'SHIP_TO', show: false},
    SHIPPING_SERVICE: {name: 'SHIPPING_SERVICE', show: false},
    PACKAGE_TYPE: {name: 'PACKAGE_TYPE', show: false},
    SIZE: {name: 'SIZE', show: false},
    WEIGHT: {name: 'WEIGHT', show: false},
  },
  REPORTS_SETTING: {
    REPORT: {label: 'report', value: 'report'},
  },
}

export const MonthlyShipmentVolume = [
  {label: 'I_SHIP_OCCASIONALLY_UNDER_10_PACKAGES_PER_MONTH', value: 'under_10'},
  {label: '11_100_PACKAGES_PER_MONTH', value: '11_100'},
  {label: '101_500_PACKAGES_PER_MONTH', value: '101_500'},
  {label: '501_1000_PACKAGES_PER_MONTH', value: '501_1000'},
  {label: '1001_5000_PACKAGES_PER_MONTH', value: '1001_5000'},
  {label: 'MORE_THAN_5000_PACKAGES_PER_MONTH', value: 'more_5000'},
]

export const Industry = [
  {label: 'APPAREL_ACCESSORIES', value: 'apparel_accessories'},
  {label: 'HEALTH_BEAUTY', value: 'health_beauty'},
  {label: 'HOME_LIVING', value: 'home_living'},
  {label: 'ELECTRONICS_TECH', value: 'electronics_tech'},
  {label: 'ARTS_CRAFTS_DIY_SUPPLIES', value: 'arts_crafts_diy_supplies'},
  {label: 'TOYS_GAMES_HOBBIES', value: 'toys_games_hobbies'},
  {label: 'JEWELRY_WATCHES', value: 'jewelry_watches'},
  {label: 'BOOKS_MEDIA_COLLECTIBLES', value: 'books_media_collectibles'},
  {label: 'FOOD_BEVERAGE', value: 'food_beverage'},
  {label: 'PET_SUPPLIES', value: 'pet_supplies'},
  {label: 'SPORTS_OUTDOOR_GEAR', value: 'sports_outdoor_gear'},
  {label: 'OFFICE_STATIONERY', value: 'office_stationery'},
  {label: 'AUTOMOTIVE_PARTS_ACCESSORIES', value: 'automotive_parts_accessories'},
  {label: 'OTHER_MISCELLANEOUS_GOODS', value: 'other_miscellaneous_goods'},
]

export const ConfigGeneral = {
  MAX_EMAIL_NUMBER: 3,
  MAX_EMAIL_NUMBER_LOW_BALANCE: 6,
  NAME_TAB: {
    NOTIFICATIONS: 'notifications',
    LANGUAGE: 'language',
    TIME_ZONE: 'time-zone',
  },
  NOTIFICATION_CATEGORY: {
    METER: 'meter',
    CLAIMS: 'claims',
    TRACKING: 'customer_tracking',
  },
  NOTIFICATION_TYPE: {
    EMAIL: 'email',
  },
}

// profile
export const OPTIONS_SERVICES = [
  {
    label: 'USPS',
    value: 'usps',
  },
  {
    label: 'UPS',
    value: 'ups',
  },
  {
    label: 'FedEx',
    value: 'fedex',
  },
  {
    label: 'DHL',
    value: 'dhl',
  },
]

export const OPTIONS_METHODS = [
  {
    label: 'ShipBae',
    value: 'shipbae',
  },
  {
    label: 'Gori API',
    value: 'gori_api',
  },
]

export const PROMOTION_TYPES = {
  MARKET_PROMO: 'market_promo',
}

export const PROFILE_EDIT_FIELD = {
  ABOUT_YOUR: [
    {
      name: 'account_number',
      label: 'ACCOUNT_ID',
      type: 'text',
      required: true,
      disabled: true,
    },
    {
      name: 'company_name',
      label: 'ORGANIZATION',
      type: 'text',
      required: false,
      disabled: true,
    },
    {
      name: 'phone',
      label: 'PHONE',
      type: 'text',
      required: true,
    },
    {
      name: 'website_url',
      label: 'COMPANY_WEBSITE',
      type: 'text',
      required: false,
    },
    {
      name: 'monthly_shipment_volume',
      label: 'MONTHLY_SHIPMENT_VOLUME',
      type: 'select',
      required: true,
      options: MonthlyShipmentVolume,
      placeholder: 'HOW_CAN_HELP',
    },
    {
      name: 'sales_rep',
      label: 'WHO_IS_YOUR_GORI_SALES_REP',
      type: 'text',
      required: false,
      placeholder: 'SALE_REP',
    },
  ],
  BUSINESS_ADDRESS: [
    {
      name: 'country',
      label: 'COUNTRY',
      type: 'select',
      required: true,
      options: OPTION_COUNTRIES,
    },
    {
      name: 'street1',
      label: 'ADDRESS',
      type: 'address',
      required: true,
      col: 'col-12',
    },
    {
      name: 'street2',
      label: 'ADDRESS_2',
      type: 'address',
      required: false,
      col: 'col-6',
    },
    {
      name: 'city',
      label: 'CITY',
      type: 'text',
      required: true,
      col: 'col-6',
    },
    {
      name: 'zip',
      label: 'POSTAL_CODE',
      type: 'text',
      required: true,
      col: 'col-6',
    },
    {
      name: 'state',
      label: 'STATE',
      type: 'text',
      required: true,
      col: 'col-6',
    },
  ],
  PRIMARY_CONTACT: [
    {
      name: 'report_name',
      label: 'NAME',
      type: 'text',
      required: false,
      col: 'col-12',
    },
    {
      name: 'report_email',
      nameParent: 'report_emails',
      label: 'EMAILS',
      type: 'email',
      required: false,
      col: 'col-12',
    },
    {
      name: 'accounting_name',
      label: 'NAME',
      type: 'text',
      required: false,
      col: 'col-12',
    },
    {
      name: 'accounting_email',
      nameParent: 'accounting_emails',
      label: 'EMAILS',
      type: 'email',
      required: false,
      col: 'col-12',
    },
  ],
}

export const FUNDING_PREFERENCES = {
  AUTOMATION: 'automatic',
  MANUAL: 'manual',
}

export const ACCOUNT_PROFILE_FIELD = [
  {
    name: 'name',
    label: 'ACCOUNT_NAME',
    type: 'text',
    required: true,
    col: 'col-12',
  },
  {
    name: 'country',
    label: 'COUNTRY',
    type: 'select',
    required: true,
    options: OPTION_COUNTRIES,
  },
  {
    name: 'street1',
    label: 'ADDRESS',
    type: 'address',
    required: true,
    col: 'col-12',
  },
  {
    name: 'street2',
    label: 'ADDRESS_2',
    type: 'text',
    required: false,
    col: 'col-6',
  },
  {
    name: 'city',
    label: 'CITY',
    type: 'text',
    required: true,
    col: 'col-6',
  },
  {
    name: 'zip',
    label: 'POSTAL_CODE',
    type: 'text',
    required: true,
    col: 'col-6',
  },
  {
    name: 'state',
    label: 'STATE',
    type: 'text',
    required: true,
    col: 'col-6',
  },
  {
    name: 'phone',
    label: 'PHONE',
    type: 'text',
    required: false,
    col: 'col-6',
  },
  {
    name: 'shipper_code',
    label: 'SHIPPER_CODE',
    type: 'text',
    required: false,
    col: 'col-6',
  },
]
export const BALANCE_THRESHOLD = 0.2
export const INSURANCE_AMOUNT_MAX = 5000

export const SETTING_INSURANCE_TYPE = {
  ALL_PACKAGES: {
    TYPE: 'all_packages',
    DEFAULT: 125,
  },
  HIGH_VALUE_ONLY: {
    TYPE: 'high_value_only',
    DEFAULT: 200,
  },
}

export const AUTOMATION_SYNC_EXECUTION_TYPE = {
  DIRECT: 'direct',
  QUEUED: 'queued',
}

export const AUTOMATION_SYNC_RESULT_STATUS = {
  PROCESSING: 'processing',
  COMPLETED: 'completed',
  SKIPPED: 'skipped',
}
